export type AgeTone = 'calm' | 'notice' | 'late' | 'overdue';

export function getAgeTone(days: number): AgeTone {
  if (days < 1) {
    return 'calm';
  }

  if (days <= 2) {
    return 'notice';
  }

  if (days <= 5) {
    return 'late';
  }

  return 'overdue';
}

export type Deadline = {
  isPast: boolean;
  /** Whole hours remaining, negative once the deadline has passed. */
  hours: number;
};

export function getDeadline(dueAt: Date, now: Date): Deadline {
  const hours = Math.floor((dueAt.getTime() - now.getTime()) / 3_600_000);

  return { isPast: hours < 0, hours };
}

/** `in 3d`, `in 5h`, `2d late`. */
export function formatDeadline({ isPast, hours }: Deadline): string {
  const size = Math.abs(hours);
  const span = size >= 24 ? `${Math.floor(size / 24)}d` : `${size}h`;

  return isPast ? `${span} late` : `in ${span}`;
}

/** How long an order has been held: `< 1 h`, `3 h`, `2 d`, `2 d 4 h`. */
export function formatHeldFor(seconds: number): string {
  const hours = Math.floor(Math.max(0, seconds) / 3600);
  const days = Math.floor(hours / 24);
  const rest = hours % 24;

  if (hours < 1) {
    return '< 1 h';
  }

  if (days < 1) {
    return `${hours} h`;
  }

  return rest ? `${days} d ${rest} h` : `${days} d`;
}
